function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { createTheme, responsiveFontSizes } from '@mui/material';
import { baseThemeConfig, getDarkThemeConfig, getLightThemeConfig, SiteList } from '../config';
import { AppTypes, ClientNames, InjectableServices, PaletteModeCode, VendorCodes } from '../enums';
import { SuperSubject } from '../models';
import { deepMergeObjects, getClientName, getClientVendorCode } from '../util';
import { WindowedObservable } from '../windowed-observable';
import { BaseConfigService } from './base-config.service';
export var ThemeService = /*#__PURE__*/ function(BaseConfigService) {
    "use strict";
    _inherits(ThemeService, BaseConfigService);
    function ThemeService() {
        _class_call_check(this, ThemeService);
        var _this;
        _this = _call_super(this, ThemeService, arguments), _define_property(_this, "printTheme", null), _define_property(_this, "baseThemeModeSubject", new SuperSubject(PaletteModeCode.dark)), _define_property(_this, "baseThemeMode$", _this.baseThemeModeSubject.observable$), _define_property(_this, "getThemeConfig", getDarkThemeConfig), _define_property(_this, "themeMap", {});
        return _this;
    }
    _create_class(ThemeService, [
        {
            key: "baseTheme",
            get: function get() {
                if (this.printTheme) {
                    return this.printTheme;
                }
                return this.themeMap[this.baseThemeModeSubject.value];
            },
            set: function set(theme) {
                this.themeMap[this.baseThemeModeSubject.value] = theme;
            }
        },
        {
            key: "getOrCreateTheme",
            value: function getOrCreateTheme(mode, clientSettings, forceCreate, themeConfig) {
                var themeKey = (themeConfig === null || themeConfig === void 0 ? void 0 : themeConfig.key) ? "".concat(mode, "-").concat(themeConfig === null || themeConfig === void 0 ? void 0 : themeConfig.key) : mode;
                if (this.themeMap[themeKey] && !forceCreate && !this.printTheme) {
                    return this.themeMap[themeKey];
                }
                var themeOptions = this.getThemeConfig(mode);
                var theme = createTheme(this.baseTheme, (themeConfig === null || themeConfig === void 0 ? void 0 : themeConfig.key) ? deepMergeObjects(themeOptions, themeConfig.config) : themeOptions);
                if (!this.printTheme) {
                    this.themeMap[themeKey] = theme;
                }
                return theme;
            }
        },
        {
            key: "initializeBaseTheme",
            value: function initializeBaseTheme(clientPortalBase, appType, isAuthenticated, userThemeMode, appThemeConfig) {
                this.themeMap = {};
                // Override color palette if domain is not Procom
                var clientThemeConfig = null;
                var clientName = clientPortalBase ? getClientName(clientPortalBase) : ClientNames.Procom;
                var clientVendorCode = clientPortalBase ? getClientVendorCode(clientPortalBase) : VendorCodes.PCGL;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // eslint-disable-next-line no-restricted-syntax
                    for(var _iterator = SiteList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var portal = _step.value;
                        if (portal.name === clientName && portal.vendorCode === clientVendorCode) {
                            var themeMode = void 0;
                            if (isAuthenticated) {
                                var _portal_settings_defaultThemeMode;
                                themeMode = userThemeMode !== null && userThemeMode !== void 0 ? userThemeMode : (_portal_settings_defaultThemeMode = portal.settings.defaultThemeMode) === null || _portal_settings_defaultThemeMode === void 0 ? void 0 : _portal_settings_defaultThemeMode.authenticated;
                            } else if (appType === AppTypes.auth) {
                                var _portal_settings_defaultThemeMode1;
                                themeMode = (_portal_settings_defaultThemeMode1 = portal.settings.defaultThemeMode) === null || _portal_settings_defaultThemeMode1 === void 0 ? void 0 : _portal_settings_defaultThemeMode1.guestAuth;
                            } else if (appType === AppTypes.client) {
                                var _portal_settings_defaultThemeMode2;
                                themeMode = (_portal_settings_defaultThemeMode2 = portal.settings.defaultThemeMode) === null || _portal_settings_defaultThemeMode2 === void 0 ? void 0 : _portal_settings_defaultThemeMode2.guestClient;
                            }
                            this.baseThemeModeSubject.value = themeMode !== null && themeMode !== void 0 ? themeMode : PaletteModeCode.dark;
                            this.getThemeConfig = this.baseThemeModeSubject.value === PaletteModeCode.light ? getLightThemeConfig : getDarkThemeConfig;
                            clientThemeConfig = deepMergeObjects(baseThemeConfig, this.getThemeConfig(this.baseThemeModeSubject.value));
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                clientThemeConfig = clientThemeConfig || baseThemeConfig;
                clientThemeConfig = appThemeConfig ? deepMergeObjects(clientThemeConfig, appThemeConfig) : clientThemeConfig;
                var theme = responsiveFontSizes(createTheme(clientThemeConfig));
                // Based on https://mui.com/material-ui/customization/typography/#responsive-font-sizes
                theme.typography.body1.fontSize = '1.6rem';
                delete theme.typography.body1[theme.breakpoints.up('sm')];
                delete theme.typography.body1[theme.breakpoints.up('md')];
                delete theme.typography.body1[theme.breakpoints.up('lg')];
                theme.typography.body2.fontSize = '1.4rem';
                delete theme.typography.body2[theme.breakpoints.up('sm')];
                delete theme.typography.body2[theme.breakpoints.up('md')];
                delete theme.typography.body2[theme.breakpoints.up('lg')];
                theme.typography.h6.fontSize = '1.6rem';
                this.baseTheme = theme;
                return theme;
            }
        },
        {
            key: "resetPrintTheme",
            value: function resetPrintTheme() {
                this.printTheme = null;
            }
        },
        {
            key: "getPrintBaseTheme",
            value: function getPrintBaseTheme(clientPortalBase, appType, isAuthenticated, userThemeMode, appThemeConfig) {
                // Override color palette if domain is not Procom
                var clientThemeConfig = null;
                var clientName = clientPortalBase ? getClientName(clientPortalBase) : ClientNames.Procom;
                var clientVendorCode = clientPortalBase ? getClientVendorCode(clientPortalBase) : VendorCodes.PCGL;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // eslint-disable-next-line no-restricted-syntax
                    for(var _iterator = SiteList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var portal = _step.value;
                        if (portal.name === clientName && portal.vendorCode === clientVendorCode) {
                            var themeMode = void 0;
                            if (isAuthenticated) {
                                var _portal_settings_defaultThemeMode;
                                themeMode = userThemeMode !== null && userThemeMode !== void 0 ? userThemeMode : (_portal_settings_defaultThemeMode = portal.settings.defaultThemeMode) === null || _portal_settings_defaultThemeMode === void 0 ? void 0 : _portal_settings_defaultThemeMode.authenticated;
                            } else if (appType === AppTypes.auth) {
                                var _portal_settings_defaultThemeMode1;
                                themeMode = (_portal_settings_defaultThemeMode1 = portal.settings.defaultThemeMode) === null || _portal_settings_defaultThemeMode1 === void 0 ? void 0 : _portal_settings_defaultThemeMode1.guestAuth;
                            } else if (appType === AppTypes.client) {
                                var _portal_settings_defaultThemeMode2;
                                themeMode = (_portal_settings_defaultThemeMode2 = portal.settings.defaultThemeMode) === null || _portal_settings_defaultThemeMode2 === void 0 ? void 0 : _portal_settings_defaultThemeMode2.guestClient;
                            }
                            var baseThemeModeSubject = themeMode !== null && themeMode !== void 0 ? themeMode : PaletteModeCode.dark;
                            this.getThemeConfig = baseThemeModeSubject === PaletteModeCode.light ? getLightThemeConfig : getDarkThemeConfig;
                            clientThemeConfig = deepMergeObjects(baseThemeConfig, this.getThemeConfig(baseThemeModeSubject));
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                clientThemeConfig = clientThemeConfig || baseThemeConfig;
                clientThemeConfig = appThemeConfig ? deepMergeObjects(clientThemeConfig, appThemeConfig) : clientThemeConfig;
                this.printTheme = createTheme(clientThemeConfig);
                return this.printTheme;
            }
        }
    ], [
        {
            key: "getOrCreate",
            value: function getOrCreate() {
                var observable = new WindowedObservable(InjectableServices.ThemeService);
                var state = observable.getLastEvent();
                if (state) {
                    return state;
                }
                var instance = new ThemeService();
                observable.publish(instance);
                return instance;
            }
        }
    ]);
    return ThemeService;
}(BaseConfigService);
